module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/184c344a10392a68baad7b825db5a822.gif";